import { GroupTypeBase, Styles } from 'react-select';
import { ISelectorOption } from 'types/ISelectorOption';
import { CSSObject } from '@emotion/serialize';

const breakpoints = [576, 768, 992, 1200];

const mq = breakpoints.map((bp) => `@media screen and (maX-width: ${bp}px)`);

const cardStyle: Partial<Styles<ISelectorOption, boolean, GroupTypeBase<ISelectorOption>>> = {
  menu: (provided): CSSObject =>
    ({
      ...provided,
      position: 'absolute',
      width: '100%',
      backgroundColor: 'rgba(0, 0, 0, 1)',
      borderColor: 'rgba(255, 255, 255, 1)',
      borderWidth: '1px',
      borderRadius: '5px',
      marginTop: '1px',
      [mq[0]]: {
        bottom: '0',
        top: '-800%',
      },
    } as CSSObject),
  menuList: (provided): CSSObject =>
    ({
      ...provided,
      color: 'rgba(255, 255, 255, 1)',
      textAlign: 'center',
      overflow: 'hidden',
      cursor: 'pointer',
    } as CSSObject),
  container: (provided): CSSObject =>
    ({
      ...provided,
      [mq[0]]: {
        width: '100%',
        paddingRight: '15px',
        paddingLeft: '0px',
        marginRight: 'auto',
        marginLeft: 'auto',
      },
    } as CSSObject),
  singleValue: (provided): CSSObject =>
    ({
      ...provided,
      color: 'var(--primary)',
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 'bold',
      left: 0,
      [mq[0]]: {
        marginLeft: '1px',
        fontSize: '8px',
      },
    } as CSSObject),
  valueContainer: (provided): CSSObject => ({
    ...(provided as CSSObject),
    justifyContent: 'center',
  }),
  option: (state): CSSObject => {
    const defaultControlStyles: CSSObject = {
      width: '100%',
      boxSizing: 'border-box',
      padding: '5px 0px',
      fontSize: '0.8rem',
      fontWeight: 'lighter',
      [mq[0]]: {
        padding: '0px 0px',
        fontSize: '0.5rem',
      },
    };
    const focusedControlStyles: CSSObject = {};
    const selectedControlStyles: CSSObject = {};

    if (state.isSelected) return selectedControlStyles;
    if (state.isFocused) return focusedControlStyles;

    return defaultControlStyles as CSSObject;
  },
  indicatorsContainer: (): CSSObject => ({
    color: 'var(--danger)',
    'div:nth-of-type(1n)': {
      [mq[0]]: {
        padding: '0px',
      },
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'var(--primary)',
  }),
  control: (state): CSSObject => {
    const defaultControlStyle: CSSObject = {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      position: 'relative',
      transition: 'all 100ms',
      maxHeight: 10,
      cursor: 'pointer',
    };

    const focusedControlStyles: CSSObject = {
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 1)',
      borderColor: 'rgba(255, 255, 255, 1)',
      borderRadius: 5,
      borderWidth: 1,
      boxShadow: '0 0 10px rgba(247, 148, 28, .1)',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: 47,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      boxSizing: 'border-box',
      width: '100%',
      cursor: 'pointer',
    };

    return state.isFocused ? focusedControlStyles : defaultControlStyle;
  },
};

export const errorStyles: Partial<
  Styles<ISelectorOption, boolean, GroupTypeBase<ISelectorOption>>
> = {
  option: (provided, state) => cardStyle.option?.(provided, state) || {},
  control: () => {
    const controlHasErrorStyle: CSSObject = {
      alignItems: 'center',
      backgroundColor: 'hsl(0, 0%, 100%)',
      borderColor: '#ed4c78',
      borderRadius: 4,
      borderWidth: 1,
      boxShadow: '0 0 10px rgba(247, 148, 28, .1)',
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: 47,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      boxSizing: 'border-box',
    };

    return controlHasErrorStyle;
  },
};

export default cardStyle;
